const FORM_TYPE = 'form_type_0';
const STEP_TYPE = 'step_type_1';
const FIELDSET_TYPE = 'fieldset_type_2';
const FIELD_TYPE = 'field_type_3';
const TAG_MODEL = 'div';
const VALIDATION_TYPE = 'validation_type_4';

const FORM_MODEL_TYPES = [
  FORM_TYPE,
  STEP_TYPE,
  FIELDSET_TYPE,
  FIELD_TYPE,
];

const MODEL_TYPES = [
  ...FORM_MODEL_TYPES,
  VALIDATION_TYPE,
];

const MODEL_TO_STATE = {
  [STEP_TYPE]: 'steps',
  [FIELDSET_TYPE]: 'fieldsets',
  [FIELD_TYPE]: 'fields',
  [FORM_TYPE]: 'forms',
  [VALIDATION_TYPE]: 'validations',
};

export {
  FORM_TYPE,
  STEP_TYPE,
  FIELDSET_TYPE,
  FIELD_TYPE,
  FORM_MODEL_TYPES,
  MODEL_TYPES,
  MODEL_TO_STATE,
  TAG_MODEL,
  VALIDATION_TYPE,
};
